import { datadogRum } from "@datadog/browser-rum";

type LoginMetricType = "password" | "sso";

const LOGIN_DURATION_METRIC_KEY = "alaffia.loginDurationMetric";

interface LoginDurationMetric {
  loginType: LoginMetricType;
  startedAt: number;
}

const readLoginDurationMetric = (): LoginDurationMetric | null => {
  try {
    const rawMetric = sessionStorage.getItem(LOGIN_DURATION_METRIC_KEY);
    if (!rawMetric) return null;

    const metric = JSON.parse(rawMetric) as Partial<LoginDurationMetric>;
    if (
      (metric.loginType !== "password" && metric.loginType !== "sso") ||
      typeof metric.startedAt !== "number"
    ) {
      return null;
    }

    return metric as LoginDurationMetric;
  } catch {
    return null;
  }
};

export const startLoginDurationMetric = (loginType: LoginMetricType) => {
  try {
    sessionStorage.setItem(
      LOGIN_DURATION_METRIC_KEY,
      JSON.stringify({
        loginType,
        startedAt: Date.now(),
      } satisfies LoginDurationMetric),
    );
  } catch {
    // RUM instrumentation should never block login.
  }
};

export const discardLoginDurationMetric = () => {
  try {
    sessionStorage.removeItem(LOGIN_DURATION_METRIC_KEY);
  } catch {
    // RUM instrumentation should never block login.
  }
};

export const completeLoginDurationMetric = () => {
  const metric = readLoginDurationMetric();
  discardLoginDurationMetric();

  if (!metric) return;

  datadogRum.addAction("login.completed", {
    duration_ms: Date.now() - metric.startedAt,
    login_type: metric.loginType,
  });
};
